module.exports = __webpack_public_path__ + "img/icon_scroll-08.8095422f.png";